import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app/App';
import { SessionProvider } from './app/session';
import { ApiError } from './lib/api';
import './index.css';
import { setupPwa } from './app/pwa';

setupPwa();

// Tema: escolha salva ou a do sistema.
try {
  const theme = localStorage.getItem('atd.theme');
  const dark = theme ? theme === 'dark' : window.matchMedia('(prefers-color-scheme: dark)').matches;
  document.documentElement.classList.toggle('dark', dark);
} catch {
  // armazenamento indisponível: tema claro
}

// Chrome do Android: ao sair de um vídeo em tela cheia, a página às vezes volta com zoom e
// deslocada. Reaplicar o viewport (com escala máxima 1 por um instante) força a escala original.
const resetViewportZoom = () => {
  if (document.fullscreenElement) return;
  const meta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  if (!meta) return;
  const original = meta.content;
  meta.content = `${original}, maximum-scale=1`;
  window.setTimeout(() => {
    meta.content = original;
    window.scrollTo({ left: 0, top: window.scrollY });
  }, 300);
};
document.addEventListener('fullscreenchange', resetViewportZoom);
document.addEventListener('webkitfullscreenchange', resetViewportZoom);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Os avisos em tempo real mandam reler; não precisa reler ao focar a janela.
      refetchOnWindowFocus: false,
      staleTime: 15_000,
      retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <SessionProvider>
          <App />
        </SessionProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
